// ── 계약 접수 확인 모달 컴포넌트 ─────────────────────────────────────────────
// 계약완료 저장 전 "수정 불가" 안내 후 최종 확인

import React from 'react';
import Modal from '../../../components/Modal';
import { TXT } from '../../../components/meetingmap/utils';
import { ghostActionStyle, primaryActionStyle } from '../../../components/meetingmap/styles';

export function ContractConfirmModal({ open, onClose, onConfirm, savingResult }) {
  return (
    <Modal
      open={open}
      title="계약 접수 확인"
      icon="✅"
      onClose={onClose}
      width="min(340px, 96vw)"
      mobileSheet
      footer={(
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button type="button" style={ghostActionStyle} onClick={onClose}>
            취소
          </button>
          <button
            type="button"
            style={primaryActionStyle}
            disabled={savingResult}
            onClick={onConfirm}
          >
            {savingResult ? TXT.saving : '접수하기'}
          </button>
        </div>
      )}
    >
      {/* 계약 접수 후에는 결과를 수정할 수 없음을 안내 */}
      <div style={{ padding: '4px 0 8px', fontSize: 14, color: 'var(--text-sub)', lineHeight: 1.7 }}>
        저장하면 이 결과는 <strong>수정이 불가</strong>합니다.<br />
        계약을 접수하시겠습니까?
      </div>
    </Modal>
  );
}
